import { labelFor } from './allKnownDetailsUtils';
import type { KnownSourceGroup } from '../types';

export interface SingleGroupEntry {
    kind: 'single';
    group: KnownSourceGroup;
}

export interface ClusteredGroupEntry {
    kind: 'cluster';
    label: string;
    groups: KnownSourceGroup[];
}

export type SourceGroupEntry = SingleGroupEntry | ClusteredGroupEntry;

/** Clusters consecutive groups sharing a label when any carries an instanceLabel; a lone group stays standalone. */
export const clusterSourceGroups = (groups: KnownSourceGroup[]): SourceGroupEntry[] => {
    const labels = groups.map(labelFor);
    const entries: SourceGroupEntry[] = [];
    let index = 0;

    while (index < groups.length) {
        let end = index + 1;
        while (end < groups.length && labels[end] === labels[index]) end++;

        const run = groups.slice(index, end);
        if (run.length > 1 && run.some((group) => group.instanceLabel !== undefined)) {
            entries.push({ kind: 'cluster', label: labels[index], groups: run });
        } else {
            run.forEach((group) => entries.push({ kind: 'single', group }));
        }
        index = end;
    }

    return entries;
};
